import React from "react";
import { DashboardStatCard } from "./HomeStatCard";
import { HomeAnalyticsCharts } from "./HomeAnalytics";
import { DashboardStoreData } from "./HomeStoresData";

export const SellerDashboardHome: React.FC = () => {
    return (
        <main>
            <DashboardStatCard />
            <HomeAnalyticsCharts />
            <DashboardStoreData />
        </main>
    );
};